import { useState } from 'react';
import WhiteBoxContent from 'src/components/common/WhiteBoxContent';
import { AI_HS_CODE_LABELING_TAB_KEY } from 'src/features/AIHSCodeLabeling/config';
import FormBulkUploadSearch from 'src/features/AIHSCodeLabeling/FormBulkUploadSearch';
import FormSingleSearch from 'src/features/Public/AIHSCodeLabeling/FormSingleSearch';

const AIHSCodeLabeling = () => {
  const [selectedTab, setSelectedTab] = useState(AI_HS_CODE_LABELING_TAB_KEY.single_search);

  const renderForm = () => {
    switch (selectedTab) {
      case AI_HS_CODE_LABELING_TAB_KEY.single_search:
        return <FormSingleSearch />;
      case AI_HS_CODE_LABELING_TAB_KEY.bulk_uploading_search:
        return <FormBulkUploadSearch />;
      default:
        return null;
    }
  };

  return (
    <WhiteBoxContent>
      {/* <ToggleTab
            selected={selectedTab}
            handleChange={(_, tab) => {
              setSelectedTab(tab as AI_HS_CODE_LABELING_TAB_KEY);
            }}
            tabs={AI_HS_CODE_LABELING_TABS}
          /> */}

      {renderForm()}
    </WhiteBoxContent>
  );
};

export default AIHSCodeLabeling;
